import FlashPCBMarkdown from "../../FlashPCBMarkdown";

import {
  Header1,
  Header2,
} from "../../FlashPCBMarkdown/FlashPCBMarkdownStyles";
import * as styledElements from "./PostStyles";
import { getByLine, PostView } from "../../../utils/posts";
import { datetimeStringToHumanReadableDate } from "../../../utils/valueFormatting";

interface PostProps {
  post: PostView;
}

const Post = ({ post }: PostProps) => {
  return (
    <styledElements.Container>
      <styledElements.Header>
        <styledElements.TitleBlock>
          <Header1>{post.title}</Header1>
          {post.subtitle && <Header2>{post.subtitle}</Header2>}
        </styledElements.TitleBlock>
        <styledElements.Details>
          <div>
            <styledElements.Pill>{post.type}</styledElements.Pill>
          </div>
          {datetimeStringToHumanReadableDate(post.date_released)}
          <styledElements.ByLine>{getByLine(post)}</styledElements.ByLine>
        </styledElements.Details>
      </styledElements.Header>
      <styledElements.PostContainer>
        <FlashPCBMarkdown
          markdown={post.markdown as string}
          externalLinks={() => true}
        />
      </styledElements.PostContainer>
    </styledElements.Container>
  );
};

export default Post;
